<template>
	<div class="tp-parentdiv d-flex">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>

		<div class="sec-child">
			<!-- {{ !isLocked}} -->
			<template v-if="sectionDetails.length === 0 && LoaderStatus == false">
				<div
					class="addtopicbox d-flex justify-content-center align-items-center"
					v-b-modal.sectionNameModal
					@click="$v.$reset()"
					v-if="roles.includes('PUSH_SECTION')"
				>
					<div class="text-center pointer">
						<img src="../../assets/addsecicon.svg" alt="" />
						<div class="addtopictext mt-2">Add New Section</div>
					</div>
				</div>

				<div class="qp-emptycard-design">
					<span>To begin creating a new section</span>
					<span>Click on "Add New Section" button</span>
				</div>
			</template>

			<template v-else-if="sectionDetails.length !== 0">
				<div
					class="headtext d-flex align-items-center w-100 justify-content-between"
				>
					<div style="width: 45%" class="d-flex">
						<div class="mr-2" v-if="!viewQuestionBank">
							<img
								src="../../assets/icons/Reports/bckarrow.svg"
								alt=""
								class="mb-1 pointer mr-2"
								@click="goTobackpage()"
							/>
						</div>
						<div class="heading" v-if="!viewQuestionBank">
							<div
								class="text-truncate"
								style="width: 45%"
								v-if="$route.params.testName.length > 69"
								v-b-popover.hover.top="$route.params.testName"
							>
								{{ $route.params.testName }}
							</div>
							<div v-else>{{ $route.params.testName }}</div>
						</div>
					</div>
					<div style="width: 45%">
						<div
							style="width: fit-content"
							class="warning-box d-flex p-1"
							v-if="isLocked && !viewQuestionBank && LoaderStatus == false"
						>
							<img src="../../assets/icons/Qpbuilder/warning.svg" alt="" />
							This test is locked and can only be shared. You can not do any
							actions
						</div>
					</div>

					<div
						style="width: 10%"
						class="d-flex justify-content-end"
						v-if="
							!viewQuestionBank &&
								(roles.includes('GET_TEST_INDIVIDUAL') ||
									roles.includes('GET_TEST_GROUP'))
						"
					>
						<b-button
							class="addbtn"
							@click="goToGroupShare()"
							:disabled="no_questions"
							v-b-tooltip.hover
							:title="
								no_questions ? 'To Enable Add Questions To All Sections' : ''
							"
						>
							Share
						</b-button>
					</div>
					<div v-else style="width: 10%"></div>
				</div>

				<div
					class="d-flex align-items-center"
					:class="
						viewQuestionBank ? 'view-sec-main-container' : 'sec-main-container'
					"
				>
					<div
						class="qpbuilder-sec-leftside"
						:class="!roles.includes('GET_QUESTION_BANK') ? 'width100' : ''"
						v-if="!viewQuestionBank"
						key="slide-qb"
					>
						<div class="secsub-leftside">
							<div class="align-items-center pl-3 pr-3">
								<b-row>
									<b-col cols="6">
										<div class="relativeclass">
											<div
												:class="!isLocked ? '' : 'disableSharing'"
												class="relativeclass mt-3 pointer"
												@click="
													!isLocked
														? ((sectionmodal = !sectionmodal),
														  (showquesoptions = false))
														: null
												"
												ref="sectionparent"
											>
												<div class="fieldsetStyle section-text">
													Select a Section
												</div>
												<div
													class="section-content d-flex justify-content-between align-items-center qpb-typeradio"
												>
													<div
														class="sectionname"
														v-if="sectionsvalue.name.length > 24"
														v-b-popover.hover.top="sectionsvalue.name"
													>
														{{ sectionsvalue.name | testNameFilter }}
													</div>
													<div class="sectionname" v-else>
														{{ sectionsvalue.name }}
													</div>
													<div
														class="d-flex justify-content-between align-items-center"
													>
														<div
															v-if="sectionsvalue.codingSection"
															class="codename-disable mr-2"
														>
															Programming
														</div>
														<div
															v-else-if="sectionsvalue.communicationSection"
															class="codename-disable mr-2"
														>
															Communication
														</div>
														<div v-else class="codename-disable mr-2">
															Standard
														</div>

														<div>
															<img
																v-if="sectionmodal"
																src="../../assets/uparrow.svg"
																alt=""
															/>
															<img
																v-else
																src="../../assets/downarrow.svg"
																alt=""
															/>
														</div>
													</div>
												</div>
											</div>
											<div
												ref="sectionselect"
												v-closable="{
													exclude: ['sectionparent', 'sectionselect'],
													handler: 'hidesectionmodal',
												}"
												v-if="sectionmodal"
												class="section-modal"
												style="width: 135%;
    top: 44px;
    left: -3px;"
											>
												<div class="sec-modal-headtext">Select a Section</div>
												<div>
													<div
														class="sec-selectdropdown d-flex sec-mcq-datacard"
													>
														<b-form-select
															v-model="sectionsvalue"
															@change="selectSection(sectionsvalue)"
															:select-size="sectionDetails.length < 3 ? 2 : 3"
															class="select pointer p-0 sec-mcq-datacard overflow-auto"
														>
															<option
																class="relativeclass secdropdowncolor overflow-auto"
																:class="
																	selectedSection.sectionID == carrier.sectionID
																		? 'selected-section'
																		: ''
																"
																:value="{
																	name: carrier.name,
																	sectionID: carrier.sectionID,
																	testID: carrier.testID,
																	numbeOfQuestions: carrier.numbeOfQuestions,
																	secMarks: carrier.secMarks,
																	codingSection: carrier.codingSection,
																	communicationSection:
																		carrier.communicationSection,
																	introQuestionAdded:
																		carrier.introQuestionAdded,
																	noOfQuestionsToAnswer:
																		carrier.noOfQuestionsToAnswer,
																}"
																:key="carrier.sectionID"
																v-for="carrier in sectionDetails"
															>
																<div class="w-100 d-flex align-items-center">
																	<div
																		style="width: 85%"
																		class="position-relative"
																	>
																		{{ carrier.name }}
																		<div
																			style="width: 15%"
																			v-if="carrier.codingSection"
																			class="codename-disable"
																		>
																			(Programming)
																		</div>
																		<div
																			v-else-if="carrier.communicationSection"
																			class="codename-disable"
																		>
																			(Communication)
																		</div>
																		<div
																			style="width: 15%"
																			v-else
																			class="codename-disable"
																		>
																			(Standard)
																		</div>
																	</div>
																</div>
															</option>
														</b-form-select>
													</div>
												</div>
												<div
													class="secmodaltwobtns d-flex pointer justify-content-between"
												>
													<div class="d-flex align-items-center">
														<div
															class="d-flex"
															v-if="roles.includes('PUSH_SECTION')"
															v-b-modal.sectionNameModal
															@click="
																$v.$reset(),
																	(secOptionselected = ''),
																	(section.communicationSection = false)
															"
														>
															<img
																src="../../assets/secplusicon.svg"
																alt=""
																class="mr-2"
															/>
															<div class="sec-addquestext mr-3 fw-600">
																New Section
															</div>
														</div>
														<div
															class="d-flex ml-3"
															v-b-modal.sectionNameModal
															@click="
																$v.$reset(),
																	(secOptionselected = 'communication'),
																	(section.communicationSection = true)
															"
														>
															<img
																src="../../assets/secplusicon.svg"
																alt=""
																class="mr-2"
															/>
															<div class="sec-addquestext mr-3 fw-600">
																Communication Test
															</div>
														</div>
														<div
															class="d-flex ml-3"
															v-b-modal.addcodetest
															v-if="roles.includes('PUSH_QUESTION')"
														>
															<img
																src="../../assets/secplusicon.svg"
																alt=""
																class="mr-2"
															/>
															<div class="sec-addquestext mr-3 fw-600">
																Coding Test
															</div>
														</div>
													</div>

													<div class="">
														<div
															class="sec-canceltext"
															@click="sectionmodal = !sectionmodal"
														>
															Cancel
														</div>
													</div>
												</div>
											</div>
										</div>
									</b-col>
									<b-col cols="3">
										<div
											class="autoqp-markcontainer d-flex align-items-center justify-content-between mt-3"
										>
											<div class="d-flex flex-column align-items-center">
												<div class="lightgreentext">
													{{ allquestioncount }}
												</div>
												<div class="qp-right-topbar-text">Questions</div>
											</div>

											<div class="d-flex flex-column align-items-center">
												<div class="pinknumbertext">
													{{ totalmarkscount }}
												</div>
												<div class="qp-right-topbar-text">Marks</div>
											</div>
										</div>
									</b-col>
									<b-col cols="1"></b-col>
									<b-col class="" cols="2">
										<div
											class="d-flex pointer justify-content-end align-items-center mt-4"
										>
											<div
												v-if="roles.includes('PUT_SECTION')"
												class="sec-addcheckboxtext mr-3 d-flex align-items-center"
												@click="
													!isLocked
														? ((editModal = !editModal), copySectionData())
														: null
												"
												:class="!isLocked ? '' : 'disableSharing'"
											>
												<span
													><img
														src="../../assets/icons/Qpbuilder/edit.svg"
														alt=""
												/></span>
												<span class="ml-2">Edit</span>
											</div>
											<div
												:class="!isLocked ? '' : 'disableSharing'"
												v-if="roles.includes('DELETE_SECTION')"
												class="sec-addcheckboxtext mr-3 d-flex align-items-center"
												@click="!isLocked ? (deleteModal = !deleteModal) : null"
											>
												<span
													><img
														src="../../assets/icons/Qpbuilder/delete.svg"
														alt=""
												/></span>
												<span class="">Delete</span>
											</div>
										</div>
									</b-col>
								</b-row>
							</div>

							<hr />
							<div
								class="d-flex justify-content-between mt-3"
								v-if="showcodetest == false && !showComutest"
							>
								<div class="d-flex">
									<div class="relativeclass ml-3">
										<div class="secbox-head">MCQ</div>
										<div class="bluenumbertext sec-quesbox">
											{{ mcqQuestionCount }}
										</div>
									</div>
									<div class="relativeclass ml-3">
										<div class="secbox-head">MTF</div>
										<div class="yellownumbertext sec-quesbox">
											{{ mafoQuestionCount }}
										</div>
									</div>
									<div class="relativeclass ml-3">
										<div class="secbox-head">Descriptive</div>
										<div class="yellownumbertext sec-quesbox">
											{{ longQuestionCount }}
										</div>
									</div>
								</div>
								<div>
									<div
										:class="!isLocked ? '' : 'disableSharing'"
										class="d-flex relativeclass align-items-center justify-content-end mr-3 pointer"
									>
										<img
											ref="showquesoptions3"
											v-if="roles.includes('PUSH_QUESTION')"
											@click="
												!isLocked
													? ((showquesoptions = !showquesoptions),
													  (sectionmodal = false))
													: null
											"
											src="../../assets/secplusicon.svg"
											alt=""
										/>
										<div
											ref="showquesoptions1"
											v-if="roles.includes('PUSH_QUESTION')"
											@click="
												!isLocked
													? ((showquesoptions = !showquesoptions),
													  (sectionmodal = false))
													: null
											"
											class="sec-addquestext ml-2"
										>
											Add Question
										</div>
										<div
											ref="showquesoptions2"
											v-if="roles.includes('PUSH_QUESTION')"
											@click="
												!isLocked ? (showquesoptions = !showquesoptions) : null
											"
											class="ml-2"
										>
											<img
												v-if="!showquesoptions"
												src="../../assets/assess-main-downArrow.svg"
												alt=""
											/>
											<img
												v-else
												src="../../assets/assess-main-upArrow.svg"
												alt=""
											/>
										</div>
										<div
											v-if="showquesoptions"
											ref="showquesoptions"
											class="sec-dropdown"
											v-closable="{
												exclude: [
													'showquesoptions',
													'showquesoptions1',
													'showquesoptions2',
													'showquesoptions3',
												],
												handler: 'hideshowoptions',
											}"
										>
											<div
												v-for="(ques, index) in questiontype_options"
												:key="index"
												class="secdropdowncolor"
											>
												<div
													class="p-1"
													@click="selectTypeQuestion(ques.value)"
													:class="
														addquestion == ques.value ? 'selected-section' : ''
													"
												>
													{{ ques.text }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div
								class="d-flex justify-content-between"
								v-if="showcodetest && !showComutest"
							>
								<div class="d-flex">
									<div class="relativeclass ml-3">
										<div class="secbox-head">Coding Question</div>
										<div class="bluenumbertext sec-quesbox">
											<span> {{ CodingQuestionCount }} </span>
										</div>
									</div>
								</div>
								<div>
									<b-button class="addbtn mr-2" @click="goToCreateQuestion">
										<img src="../../assets/plusicon.svg" alt="" class="mr-2" />
										<span class="">Create Question</span>
									</b-button>
								</div>
							</div>
							<div
								class="d-flex justify-content-between"
								v-if="!showcodetest && !showadd && showComutest"
							>
								<div class="d-flex align-items-center gap-2">
									<div class="d-flex">
										<div class="relativeclass ml-3">
											<div
												class="secbox-head"
												style="font-size: 8px; position:absolute;bottom: 39px;left: 5px;"
											>
												Communication Question
											</div>
											<div class="bluenumbertext sec-quesbox">
												<span> {{ CommunicationQuestionCount }} </span>
											</div>
										</div>
									</div>
									<div class="d-flex">
										<div class="relativeclass ml-3">
											<div
												class="secbox-head"
												style="font-size: 8px; position:absolute;bottom: 39px;left: 5px;padding: 0 3px;"
											>
												Question to Answer&nbsp;<span class="asterik">*</span>
											</div>
											<b-form-input
												:class="{ error: showCommunicationQuestionError }"
												v-model="noOfQuestionsToAnswer"
												@keypress.native="onlyNumbers($event)"
												@input.native="handleQTAInput"
												class="sec-quesbox fs-14 fw-600 color-mainblue font-poppins"
												style="  width: 120px; padding: 0 10px;border: 1px solid #20639b;"
												:disabled="CommunicationQuestionCount == '0'"
												type="text"
												:max="CommunicationQuestionCount"
												:min="1"
											></b-form-input>
											<small
												v-if="showCommunicationQuestionError"
												class="text-danger"
												style="font-size: 10px; position: absolute; width: max-content;"
											>
												{{ communicationErrorMsg }}
											</small>
										</div>
									</div>
								</div>
								<div class="d-flex align-items-center gap-4">
									<div class="mcq-checkbox">
										<b-form-checkbox
											name="some-radios"
											v-model="addIntroQues"
											@change="handleIntroChange"
										>
											Add Introduction Question
										</b-form-checkbox>
									</div>
									<div
										:class="!isLocked ? '' : 'disableSharing'"
										class="d-flex relativeclass align-items-center justify-content-end mr-3 pointer"
									>
										<img
											ref="showquesoptions3"
											v-if="roles.includes('PUSH_QUESTION')"
											src="../../assets/secplusicon.svg"
											alt=""
										/>
										<div
											ref="showquesoptions1"
											v-if="roles.includes('PUSH_QUESTION')"
											@click="selectTypeQuestion('COMU')"
											class="sec-addquestext ml-2"
										>
											Add Question
										</div>
									</div>
								</div>
							</div>
						</div>

						<template v-if="(showadd || showComutest) && showcodetest == false">
							<div class="secsub-second-leftside" id="addcontainer">
								<div
									class="secleftquescard"
									v-for="(item, index) in questionData"
									:key="item['questionKey']"
								>
									<template
										v-if="
											item['questionKey'].slice(0, 4) == 'MCQU' && !showComutest
										"
									>
										<MCQCard
											:data="item"
											:showindex="index + 1"
											@question-deleted="questionDeleted = true"
											v-on:get-sections="getSections"
											@question-added="getAllData"
											:isLocked="isLocked"
										/>
									</template>
									<template
										v-if="
											item['questionKey'].slice(0, 4) == 'MAFO' && !showComutest
										"
									>
										<MatchCard
											:data="item"
											:showindex="index + 1"
											@question-deleted="questionDeleted = true"
											v-on:get-sections="getSections"
											@question-added="getAllData"
											:isLocked="isLocked"
										/>
									</template>
									<template
										v-if="
											item['questionKey'].slice(0, 4) == 'LONG' && !showComutest
										"
									>
										<LongAnswerCard
											:data="item"
											:showindex="index + 1"
											@question-deleted="questionDeleted = true"
											v-on:get-sections="getSections"
											:isLocked="isLocked"
											@question-added="getAllData"
											@toggle-loader="toggleLoader"
										/>
									</template>
									<template
										v-if="
											item['questionKey'].slice(0, 4) == 'COMU' && showComutest
										"
									>
										<CommunicationCard
											:data="item"
											:showindex="index + 1"
											@question-deleted="questionDeleted = true"
											v-on:get-sections="getSections"
											:isLocked="isLocked"
										/>
									</template>
								</div>
								<template v-if="isLocked && LoaderStatus == false">
									<div
										class="d-flex align-items-center justify-content-center h-100 lock-test-noquestionsadd-text"
									>
										This test is locked, so you can not add questions
									</div>
								</template>
								<template v-else>
									<div
										id="add-question"
										class=""
										v-if="roles.includes('PUSH_QUESTION')"
									>
										<template v-if="addquestion == 'MCQ'">
											<MCQ
												:type="'mcq'"
												@question-added="getAllData"
												:questions="mcqQuestion"
												@clearData="clearData('MCQ')"
												ref="mcqForm"
											/>
										</template>

										<template v-if="addquestion == 'MTF'">
											<MatchtheFollowing
												:type="'mtf'"
												@question-added="getAllData"
												:questions="mtfQuestion"
												@toggle-loader="toggleLoader"
												@clearData="clearData('MTF')"
												ref="mtfForm"
											/>
										</template>
										<template v-if="addquestion == 'Descriptive'">
											<LongForm
												:type="'long'"
												@question-added="getAllData"
												:questions="descriptiveQuestion"
												@clearData="clearData('Descriptive')"
												ref="longForm"
											/>
										</template>
										<template v-if="addquestion == 'COMU'">
											<CommunicationTest
												:type="'COMU'"
												@question-added="getAllData"
												:questions="communicationQuestion"
												@toggle-loader="toggleLoader"
												@clearData="clearData('COMU')"
												ref="commuForm"
											/>
										</template>
									</div>
								</template>
							</div>
						</template>

						<!-- <template v-if="!showadd && !showcodetest && showComutest">
							<div class="secsub-second-leftside" id="addcontainer">
								<div
									class="secleftquescard"
									v-for="(item, index) in questionData"
									:key="item['questionKey']"
								>
									<CommunicationCard
										v-if="item['questionKey'].slice(0, 4) == 'COMU'"
										:data="item"
										:showindex="index + 1"
										@question-deleted="questionDeleted = true"
										v-on:get-sections="getSections"
										:isLocked="isLocked"
									/>
								</div>
							</div>
						</template> -->
						<template v-if="showcodetest && showadd == false">
							<div
								class="secsub-second-leftside"
								v-if="questionData.length == 0"
							>
								<div
									class="d-flex flex-column align-items-center justify-content-center h-100"
								>
									<img
										src="../../assets/icons/Qpbuilder/nocodequestions.svg"
										alt=""
										class="mr-3 pointer"
									/>
									<span
										style="width: 60%; text-align: center"
										class="d-flex flex-column mt-3"
									>
										<span> Please select questions from the question bank</span>
										<span> or </span>
										<span>
											Click on “Create Question” to create new question.</span
										>
									</span>
								</div>
							</div>

							<div class="secsub-second-leftside" v-else>
								<div
									class="secleftquescard"
									v-for="(item, index) in questionData"
									:key="item['questionKey']"
								>
									<div class="secsub-left-quescontainer">
										<div class="sec-quescard d-flex flex-column">
											<div
												class="sec-quescardonopen-header d-flex mb-1 align-items-center justify-content-between"
												style="padding: 10px"
											>
												<div class="sec-quescard-headtext">Coding Question</div>
												<div class="d-flex">
													<img
														v-if="roles.includes('PUT_QUESTION')"
														v-b-popover.hover.top="'Edit'"
														src="../../assets/icons/Qpbuilder/edit.svg"
														alt=""
														class="mr-3 pointer"
														@click="goToEditQuestion(item.questionKey)"
													/>

													<img
														v-if="roles.includes('DELETE_QUESTION')"
														v-b-popover.hover.top="'Delete'"
														src="../../assets/icons/Qpbuilder/delete.svg"
														alt=""
														class="mr-3 pointer"
														@click="deleteCodeQuestionModal(item.questionKey)"
													/>
													<img
														v-b-popover.hover.top="'View'"
														src="../../assets/icons/Qpbuilder/testpreview.svg"
														alt=""
														class="pointer"
														@click="viewQuestion(item.questionKey)"
													/>
												</div>
											</div>
											<div class="d-flex relativeclass">
												<div class="codetest-colorbar mt-1"></div>
												<div
													class="ml-3 align-items-center pointer"
													style="width: 95%; padding: 20px 0"
												>
													<div class="qpc-totalQuesnum">
														Q{{ index + 1 }}.

														<span class="qpc-totalQuesnum ml-1">{{
															item.title
														}}</span>
													</div>

													<div class="sec-ques-style relativeclass">
														<template>
															<div class="d-flex">
																<div class="topicDescBreak ml-1">
																	<span> {{ item.actualQuestion }}</span>
																</div>
															</div>
														</template>
													</div>
													<div
														class="codetest-mark-tag d-flex align-items-center mt-2"
													>
														<div class="display-card-mark-text">Marks</div>
														<div class="display-card-mark-number ml-2">
															{{ item.marks }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>

					<template
						v-if="showcodetest == false && roles.includes('GET_QUESTION_BANK')"
					>
						<div
							:class="
								!viewQuestionBank || !roles.includes('GET_QUESTION_BANK')
									? 'ml-2 sec-rightside'
									: 'sec-full-container'
							"
						>
							<Databank
								ref="databank"
								:role="'PUSH_QUESTION'"
								:movestatus="moveStatus"
								:addMulti="addMulti"
								:viewQuestionBank="viewQuestionBank"
								:type="$route.query.type"
								:sort="$route.query.sort"
								:ttype="$route.query.ttype"
								:tsort="$route.query.tsort"
								:questionDeleted="questionDeleted"
								@questionsFetched="questionDeleted = false"
								v-on:changeViewQuestionBank="changeViewQuestionBank"
								v-on:changeViewDataBank="changeViewDataBank"
								v-on:question-added="getAllData"
								:isLocked="isLocked"
							/>
						</div>
					</template>
					<template
						v-if="
							showcodetest &&
								showadd == false &&
								roles.includes('GET_QUESTION_BANK')
						"
					>
						<div
							:class="
								!viewQuestionBank ? 'ml-2 sec-rightside' : 'sec-full-container'
							"
						>
							<b-overlay
								id="overlay-background"
								:show="showOverlay"
								variant="white"
								:opacity="overlayOpacity"
								:blur="overlayBlur"
								rounded="sm"
							>
								<Codetestdatabank
									:movestatus="moveStatus"
									:viewQuestionBank="viewQuestionBank"
									v-on:changeViewQuestionBank="changeViewQuestionBank"
									v-on:changeViewDataBank="changeViewDataBank"
									v-on:question-added="getAllData"
									:questionDeleted="questionDeleted"
									@questionsFetched="questionDeleted = false"
									:questionCount="maxCodingQuestions"
								/>
							</b-overlay>
						</div>
					</template>
				</div>
			</template>
		</div>

		<b-modal size="lg" id="viewQues" centered hide-footer hide-header>
			<div class="qpc-modal-head-text">View Question</div>
			<div @click="$bvModal.hide('viewQues')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="qpc-modal-card">
				<div class="d-flex align-items-center mt-3 ml-4">
					<div class="qpc-small-box">
						Difficulty Level: {{ question.difficultyLevel }}
					</div>
					<div class="qpc-small-box">Marks: {{ question.marks }}</div>
					<div class="qpc-small-box">
						Category : <b>{{ question.category }}</b>
					</div>
				</div>
				<div class="qpc-tags-text mt-3 ml-4">
					Tags :
					<div v-for="(tag, k) in question.questionTags" :key="k">
						{{ tag }}<span v-if="k < question.questionTags.length - 1">,</span>
					</div>
				</div>
				<div class="mt-3">
					<span class="qpc-totalQuesnum">Q. &nbsp;</span
					><span class="qpc-totalQuesnum ml-1">{{ question.title }}</span>
				</div>
				<div
					class="qpc-full-ques ml-4 mr-4 mt-3"
					v-html-safe="question.question"
				></div>
				<div class="qpc-left-card mt-3 ml-4 mr-4">
					<span class="qpc-modal-card-text">Constrain:</span>
					<div
						class="mt-3 qpc-tags-text"
						v-html-safe="question.constraints"
					></div>
				</div>
				<div class="qpc-left-card mt-2 ml-4 mr-4">
					<span class="qpc-modal-card-text">Sample</span>
					<div class="p-3 qpc-tags-text d-flex flex-column">
						Input: <span v-html-safe="question.sampleInput"> </span>
						Output:
						<span v-html-safe="question.sampleOutput"> </span>
					</div>
				</div>
				<template v-if="question.testCases.length > 0">
					<div class="qpc-left-card mt-2 ml-4 mr-4">
						<span class="bct-preview-head">Test Cases</span>
						<div class="d-flex">
							<div class="bct-many-testCase-left" style="width: 25%">
								<div
									v-for="(tc, k) in question.testCases"
									:key="k"
									@click="selecttestcase(k)"
									:class="
										viewtestcase == k
											? 'p-2 bct-many-testCase-sel-text'
											: 'p-2 bct-many-testCase-text pointer'
									"
								>
									Test Case {{ k + 1 }}
								</div>
							</div>
							<div class="bct-many-testCase-right" style="width: 75%">
								<div class="bct-TC-card p-3 m-2">
									<span class="bct-preview-head">Input: </span>

									<div class="bct-card-subtext mt-2">
										{{ question.testCases[viewtestcase].inputValue }}
									</div>
								</div>
								<div class="bct-TC-card p-3 m-2">
									<span class="bct-preview-head">Output: </span>
									<div class="bct-card-subtext mt-2">
										{{ question.testCases[viewtestcase].outputValue }}
									</div>
								</div>
								<div class="bct-TC-card p-3 m-2">
									<span class="bct-preview-head"
										>Visible:
										<div class="bct-card-subtext mt-2">
											{{ question.testCases[viewtestcase].visible }}
										</div></span
									>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</b-modal>

		<!-- Add code test modal starts -->

		<b-modal
			id="addcodetest"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="modalheading">Add Code Test</div>
			<div @click="closecodetestmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<b-row>
				<b-col>
					<div class="topDiv mt-3">
						<label class="fieldsetStyle"
							>Code Test Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							:class="{ error: $v.section.name.$error }"
							v-on:keyup.enter="addCodeTestSection()"
							class="inputField"
							id="input-1"
							type="text"
							autofocus
							placeholder="Enter here"
							v-model.trim="$v.section.name.$model"
						></b-form-input>
						<div
							style="position: absolute; top: 5px; right: 12px"
							v-if="$v.section.name.$dirty && !$v.section.name.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="position: absolute; top: 5px; right: 12px"
							v-if="!$v.section.name.maxLength && $v.section.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="
                position: absolute;
                top: 5px;
                right: 12px;
                background: var(--bg-white);
              "
							v-if="!$v.section.name.alpha && $v.section.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Please Enter a Valid Section Name',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<div class="d-flex justify-content-end mt-3">
				<b-button class="addbtn" @click="addCodeTestSection()">Save </b-button>
			</div>
		</b-modal>

		<!-- Add code test modal end -->

		<!-----------------  Add Popup starts -------->
		<b-modal
			id="sectionNameModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="modalheading">Add Section</div>
			<div @click="closeSectionModal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<b-form-group
				class="mt-4 sec-option-radios sec-questions-radios pointer"
				v-if="sectionDetails.length == 0"
			>
				<b-form-radio-group
					id="radio-group-1"
					v-model="secOptionselected"
					:options="sectionOptions"
					name="radio-options"
				></b-form-radio-group>
			</b-form-group>
			<div class="topDiv mt-4 relativeclass">
				<label class="fieldsetStyle"
					>Section Name &nbsp;<span class="asterik">*</span></label
				>
				<b-form-input
					:class="{ error: $v.section.name.$error }"
					v-on:keyup.enter="addSection()"
					class="inputField"
					id="input-1"
					type="text"
					autofocus
					placeholder="Enter here"
					v-model.trim="$v.section.name.$model"
				></b-form-input>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="$v.section.name.$dirty && !$v.section.name.required"
					v-b-popover.hover.top.v-danger="{ content: 'Required' }"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="!$v.section.name.maxLength && $v.section.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Should not exceed 128 characters',
					}"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="
            position: absolute;
            top: 5px;
            right: 12px;
            background: var(--bg-white);
          "
					v-if="!$v.section.name.alpha && $v.section.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Please Enter a Valid Section Name',
					}"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
			</div>
			<div class="d-flex justify-content-end mt-4">
				<b-button class="addbtn" @click="addSection()">Save</b-button>
			</div>
		</b-modal>
		<!-----------------  Add Popup ends -------->

		<b-modal
			ref="locktestnosection"
			id="locktestnosection"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span
					><strong>{{ $route.params.testName }}</strong> test is locked so you
					cannot do any actions</span
				>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="goTobackpage()">Back</b-button>
			</div>
		</b-modal>

		<b-modal
			id="deleteCodeQuestionModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div
				@click="$bvModal.hide('deleteCodeQuestionModal')"
				class="xMarkCancel"
			>
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete the selected question?</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div
				@click="deletecodequestion()"
				class="d-flex align-items-center justify-content-end mt-3"
			>
				<b-button class="addbtn">Delete</b-button>
			</div>
		</b-modal>

		<!-----------------  Edit Popup starts -------->
		<b-modal
			id="edit-section-modal"
			v-model="editModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="modalheading">Edit Section</div>
			<div @click="$bvModal.hide('edit-section-modal')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>

			<div class="topDiv mt-3 relativeclass">
				<label class="fieldsetStyle"
					>Section Name &nbsp;<span class="asterik">*</span></label
				>
				<b-form-input
					v-on:keyup.enter="editSection()"
					class="inputField"
					id="input-1"
					type="text"
					autofocus
					placeholder="Enter here"
					v-model="$v.copySection.name.$model"
					:class="{
						error: $v.copySection.name.$error,
					}"
				></b-form-input>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="$v.copySection.name.$dirty && !$v.copySection.name.required"
					v-b-popover.hover.top.v-danger="{ content: 'Required' }"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="position: absolute; top: 5px; right: 12px"
					v-if="!$v.copySection.name.maxLength && $v.copySection.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Should not exceed 128 characters',
					}"
					variant="primary"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					style="
            position: absolute;
            top: 5px;
            right: 12px;
            background: var(--bg-white);
          "
					v-if="!$v.copySection.name.alpha && $v.copySection.name.required"
					v-b-popover.hover.top.v-danger="{
						content: 'Please Enter a Valid Section Name',
					}"
				>
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
			</div>
			<div class="d-flex justify-content-end mt-3">
				<b-button class="addbtn" @click="editSection()">Update</b-button>
			</div>
		</b-modal>
		<!-----------------  Edit Popup ends -------->

		<!-----------------  Delete Popup starts -------->
		<b-modal
			id="delete-section-modal"
			v-model="deleteModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution!
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('delete-section-modal')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div v-if="!shareStatus" class="mt-3 caution-modal-text">
				<span class="wordbreak"
					>Are you sure you want to delete "{{ selectedSection.name }}" ?</span
				>
			</div>
			<div v-else class="mt-3 caution-modal-text">
				<span
					>The test has already been triggered to the candidate and the changes
					made here will impact the ongoing assessment. Do you still want to
					delete the section "{{ selectedSection.name }}"?
				</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex justify-content-end">
				<div class="d-flex align-items-center justify-content-end mt-3 mr-3">
					<b-button class="addbtn" @click="deleteSection()">Delete</b-button>
				</div>
				<div class="d-flex align-items-center justify-content-end mt-3">
					<b-button
						class="addbtn"
						@click="$bvModal.hide('delete-section-modal')"
						>Cancel</b-button
					>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Databank from "./Databank.vue";
import Codetestdatabank from "./Codetestdatabank.vue";
import { mapGetters } from "vuex";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import MatchtheFollowing from "../../components/forms/MatchTheFollowing.vue";
import MCQ from "../../components/forms/Mcq.vue";
import MCQCard from "../../components/displayCards/mcqCard.vue";
import CommunicationCard from "../../components/displayCards/CommunicationCard.vue";
import MatchCard from "../../components/displayCards/matchTheFollowingCard.vue";
import LongAnswerCard from "../../components/displayCards/longAnswerCard.vue";
import LongForm from "../../components/forms/LongForm.vue";
import CommunicationTest from "../../components/forms/CommunicationTest.vue";
import {
	testSharedCheck,
	getSection,
	getQuestions,
	postSection,
	putSection,
	deleteSection,
	getcodingquestion,
	deletecodingquestions,
	getTestOrgPagination,
	postIntroductorytest,
} from "../../utils/apiFunctions.js";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
export default {
	name: "QPBuilder",
	mixins: [successToast, errorToast],
	components: {
		Codetestdatabank,
		Databank,
		MCQCard,
		MatchCard,
		MatchtheFollowing,
		LongAnswerCard,
		LongForm,
		MCQ,
		Spinner,
		CommunicationCard,
		CommunicationTest,
	},
	data() {
		return {
			showCommunicationQuestionError: false,
			communicationErrorMsg: "",
			noOfQuestionsToAnswer: "",
			addIntroQues: null,
			secOptionselected: "standard",
			sectionOptions: [
				{ text: "Standard", value: "standard" },
				{ text: "Communication", value: "communication" },

				{ text: "Programming", value: "programng" },
			],
			QuestionIndex: null,
			question: {
				testCases: [
					{
						inputValue: "",
						outputValue: "",
						visible: "",
					},
				],
			},
			questionDeleted: false,
			viewtestcase: 0,
			testCasescount: 5,
			showcodetest: false,
			showComutest: false,
			no_questions: false,
			sortoptions_selected: "",
			addquestion: "MCQ",
			isLocked: false,
			sortColumn: "",
			nextPage: "",
			pageEnd: "",
			totalPage: "",
			currentPage: 1,
			question_count: 75,
			sortOrder: null,
			pageStart: 0,
			filtercount: 0,
			overlayOpacity: 0.46,
			overlayBlur: "4",
			viewQuestionBank: false,
			showOverlay: false,
			moveStatus: false,
			addMulti: false,
			showfiltercard: false,
			LoaderStatus: false,
			showsortcard: false,
			sectionmodal: false,
			showquesoptions: false,
			showadd: false,
			deleteModal: false,
			editModal: false,
			simp: false,
			shareStatus: false,
			section: {
				testID: this.$route.params.testID,
				portion: "Section",
				name: "",
				topicID: "",
				numberOfQuestions: 0,
				questions: [],
				secMarks: 0,
				typeOfQuestions: [],
				codingSection: "",
				communicationSection: "",
			},
			searchname: "",
			selectedSection: {},
			copySection: { ...this.selectedSection },

			sectionsvalue: {
				name: "",
				sectionID: "",
				testID: "",
				numbeOfQuestions: 0,
				secMarks: 0,
				codingSection: "",
				communicationSection: "",
			},
			sections: [],
			secoptions: [],
			sectionDetails: [],
			questionData: [],
			questionType: ["MCQU", "MAFO", "LONG"],

			mcqQuestion: {},
			mtfQuestion: {},
			communicationQuestion: {},
			descriptiveQuestion: {},
			questiontype_options: [
				{
					value: "MCQ",
					text: "Multiple Choice Question(MCQ)",
				},

				{
					value: "MTF",
					text: "Match the Followings(MTF)",
				},

				{
					value: "Descriptive",
					text: "Descriptive(DESC)",
				},
			],
		};
	},
	watch: {
		"selectedSection.communicationSection"(newVal) {
			this.addquestion = newVal ? "COMU" : "MCQ";
		},
		CommunicationQuestionCount(newVal) {
			// If no questions → reset to empty
			if (newVal === 0) {
				this.noOfQuestionsToAnswer = "";
				return;
			}

			// If only 1 question → force it to 1
			if (newVal === 1) {
				this.noOfQuestionsToAnswer = 1;
				return;
			}

			// If current value is invalid (0/null/greater) → correct it
			const val = Number(this.noOfQuestionsToAnswer);

			if (!val || val < 1) {
				this.noOfQuestionsToAnswer = 1;
				return;
			}

			if (val > newVal) {
				this.noOfQuestionsToAnswer = newVal;
			}
		},

		noOfQuestionsToAnswer() {
			// Debounce only user input
			this.debounceQuestionInput();
		},
	},
	validations: {
		section: {
			name: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
			},
		},
		copySection: {
			name: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
			},
		},
		selectedSection: {
			name: {
				required,
				maxLength: maxLength(128),
			},
		},
	},
	created: function() {
		this.LoaderStatus = true;
		this.testShareCheck();
		this.getLockedStatusAndSections();

		this.resetMcqQuestion();
		this.resetMtfQuestion();
		this.resetDescriptiveQuestion();
		this.resetCommuQuestion();
	},
	computed: {
		maxCodingQuestions() {
			let count = 0;
			for (let section of this.sectionDetails) {
				if (section.typeOfQuestions.includes("CODE"))
					count =
						section.numberOfQuestions > count
							? section.numberOfQuestions
							: count;
			}
			return count;
		},
		CodingQuestionCount() {
			let CodingQuestionCount = 0;
			for (let i in this.questionData) {
				CodingQuestionCount = Number(i) + 1;
			}
			return CodingQuestionCount;
		},
		CommunicationQuestionCount() {
			let CommunicationQuestionCount = 0;
			for (let i in this.questionData) {
				CommunicationQuestionCount = Number(i) + 1;
			}
			return CommunicationQuestionCount;
		},

		//  Get Long Question Count
		longQuestionCount() {
			let questionType = {};
			let longQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "LONG") {
					longQuestionCount++;
				}
			}
			return longQuestionCount;
		},
		//  Get Short Question Count
		shotQuestionCount() {
			let questionType = {};
			let shotQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "SHOT") {
					shotQuestionCount++;
				}
			}
			return shotQuestionCount;
		},

		// get all questions count
		allquestioncount() {
			let allquestioncount = this.questionData.length;
			return allquestioncount;
		},

		// get all marks
		totalmarkscount() {
			// Communication section → marks = noOfQuestionsToAnswer * 10
			if (this.selectedSection.communicationSection) {
				const val = Number(this.noOfQuestionsToAnswer);
				return val > 0 ? val * 10 : 0;
			}

			// Normal sections → calculate from questionData
			let totalmarkscount = 0;
			for (let i in this.questionData) {
				totalmarkscount += parseFloat(this.questionData[i].marks);
			}
			return this.naiveRound(totalmarkscount, 2);
		},

		//  Get Fitb Question Count
		fiblQuestionCount() {
			let questionType = {};
			let fiblQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "FIBL") {
					fiblQuestionCount++;
				}
			}
			return fiblQuestionCount;
		},
		//  Get Mcq Question Count
		mcqQuestionCount() {
			let questionType = {};
			let mcqQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "MCQU") {
					mcqQuestionCount++;
				}
			}
			return mcqQuestionCount;
		},
		//  Get Mafo Question Count
		mafoQuestionCount() {
			let questionType = {};
			let mafoQuestionCount = 0;
			for (let i in this.questionData) {
				questionType = this.questionData[i];
				let x = questionType.questionKey.substring(0, 4);
				if (x === "MAFO") {
					mafoQuestionCount++;
				}
			}
			return mafoQuestionCount;
		},
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
		...mapGetters(["roles"]),
	},
	methods: {
		toggleLoader(val) {
			this.LoaderStatus = val;
		},
		handleQTAInput(e) {
			this.limitTwoDigits(e);
			this.debounceQuestionInput();
		},

		onlyNumbers(e) {
			if (!/[0-9]/.test(e.key)) e.preventDefault();
		},

		limitTwoDigits(e) {
			let val = e.target.value.replace(/\D/g, ""); // allow only digits

			// ❗ stop typing after 2 digits
			if (val.length > 2) {
				val = val.slice(0, 2);
			}

			// ❗ block value 00 or 0
			if (val === "0") {
				this.noOfQuestionsToAnswer = "";
				return;
			}

			// ❗ if user types 3 digits like 123 → slice to 12
			let num = Number(val);
			if (num > 99) {
				val = val.slice(0, 2); // hard-stop at 2 digits
			}

			this.noOfQuestionsToAnswer = val;
		},
		debounceQuestionInput: (function() {
			let timer;
			return function() {
				clearTimeout(timer);
				timer = setTimeout(() => {
					this.questionToAnswer();
				}, 500);
			};
		})(),

		async questionToAnswer() {
			if (!this.selectedSection.communicationSection) {
				return;
			}
			const rawValue = this.noOfQuestionsToAnswer;
			const count = this.CommunicationQuestionCount;

			this.showCommunicationQuestionError = false;
			this.communicationErrorMsg = "";

			let finalValue = null; // default null (for count = 0 case)

			// CASE 1: when total count is 0
			if (count === 0) {
				finalValue = null;
			} else if (count === 1) {
				finalValue = 1;
			}
			// CASE 2: user input validation
			else {
				if (rawValue === "" || rawValue === null || rawValue === undefined)
					return;

				const value = Number(rawValue);

				if (value === 0) {
					this.showCommunicationQuestionError = true;
					this.communicationErrorMsg = "Value cannot be zero.";
					return;
				}
				if (value < 1) {
					this.showCommunicationQuestionError = true;
					this.communicationErrorMsg = "Minimum value should be 1.";
					return;
				}
				if (value > count) {
					this.showCommunicationQuestionError = true;
					this.communicationErrorMsg = `Cannot exceed total questions (${count}).`;
					return;
				}

				finalValue = value;
			}

			// update local state
			this.selectedSection.noOfQuestionsToAnswer = finalValue;

			const idx = this.sectionDetails.findIndex(
				(s) => s.sectionID === this.selectedSection.sectionID
			);
			if (idx !== -1) {
				this.$set(this.sectionDetails, idx, {
					...this.sectionDetails[idx],
					noOfQuestionsToAnswer: finalValue,
				});
			}
			const payload = {
				testID: this.$route.params.testID,
				sectionID: this.selectedSection.sectionID,
				topicID: this.$route.params.topicID,
				name: this.selectedSection.name,
				codingSection: false,
				communicationSection: true,
				portion: "Section",
				numberOfQuestions: count,
				secMarks: count * 10,
				noOfQuestionsToAnswer: finalValue,
				typeOfQuestions: [],
				questions: [],
			};

			try {
				const res = await putSection(payload);
				if (res.status == 200) {
					this.successToast(
						finalValue === null
							? "Question to answer reset successfully!"
							: "Question to answer updated successfully!"
					);
				}
			} catch (err) {
				console.error("Error updating section:", err);
			}
		},
		async handleIntroChange() {
			try {
				let payload = {
					testID: this.$route.params.testID,
					sectionID: this.selectedSection.sectionID,
					checked: this.addIntroQues ? "true" : "false",
				};

				const res = await postIntroductorytest(payload);
				if (res.status == 200) {
					// Update only this section's intro state
					this.selectedSection.introQuestionAdded = this.addIntroQues;

					// Also update inside sectionDetails list
					const idx = this.sectionDetails.findIndex(
						(s) => s.sectionID === this.selectedSection.sectionID
					);
					if (idx !== -1) {
						this.$set(this.sectionDetails, idx, {
							...this.sectionDetails[idx],
							introQuestionAdded: this.addIntroQues,
						});
					}
					this.debounceQuestionInput();
					this.getQuestions();
					this.getSections();
					this.checkEmptySection();
					this.successToast("Introductory Question Added successfully !");
				}
			} catch (error) {
				this.errorToast("Something went wrong!");
			}
		},
		async getLockedStatusAndSections() {
			await this.getLockedStatus();
			await this.getSections();
			this.checkConditions();
		},
		async getLockedStatus() {
			let response = await getTestOrgPagination({
				topicID: this.$route.params.topicID,
			});
			let currentSection = response.data.data.testIDs.find(
				({ testID }) => this.section.testID == testID
			);
			this.isLocked = currentSection.isLocked;
		},
		resetMcqQuestion() {
			this.mcqQuestion = {
				autoCorrection: true,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: null,
				questionType: "MCQU",
				topic: "",
				questionMedia: "",
				difficultyLevel: "",
				question: "",
				file: null,
				questionTags: [],
				options: [
					{
						value: "",
						media: "",
						check: false,
					},
					{
						value: "",
						media: "",
						check: false,
					},
				],
			};
		},
		resetCommuQuestion() {
			Object.assign(this.communicationQuestion, {
				autoCorrection: false,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: 10,
				questionType: "COMU",
				topic: "",
				questionMedia: "",
				difficultyLevel: "",
				question: "",
				file: null,
			});
		},
		resetMtfQuestion() {
			this.mtfQuestion = {
				autoCorrection: true,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: null,
				questionType: "MAFO",
				topic: "",
				difficultyLevel: "",
				question: "",
				questionMedia: "",
				file: null,
				questionTags: [],
				answerKey: [
					{
						sideA: "",
						sideB: "",
					},
					{
						sideA: "",
						sideB: "",
					},
					{
						sideA: "",
						sideB: "",
					},
				],
			};
		},
		resetDescriptiveQuestion() {
			this.descriptiveQuestion = {
				autoCorrection: false,
				autolong: false,
				required: false,
				addToPublic: false,
				addToDatabank: false,
				isFailed: false,
				marks: null,
				questionType: "LONG",
				sizelimit: 0,
				topic: "",
				difficultyLevel: "",
				question: "",
				answerKey: "",
				correctAnswer: "",
				questionMedia: "",
				file: null,
				questionTags: [],
			};
		},
		openLockTestNoSectionModal() {
			this.$bvModal.show("locktestnosection");
		},
		checkConditions() {
			if (this.isLocked && this.sectionDetails.length === 0) {
				this.openLockTestNoSectionModal();
			}
		},
		closeSectionModal() {
			this.$bvModal.hide("sectionNameModal");
			this.section.name = "";
			this.$v.$reset();
		},
		deleteCodeQuestionModal(index) {
			this.$bvModal.show("deleteCodeQuestionModal");
			this.QuestionIndex = index;
		},
		async deletecodequestion() {
			let payload = {
				sectionID: this.selectedSection.sectionID,
				testID: this.$route.params.testID,
				questionKey: this.QuestionIndex,
			};
			const res = await deletecodingquestions(payload);
			if (res.status == 200) {
				this.questionDeleted = true;
				this.successToast("Question Deleted Successfully");
				this.getQuestions();
				this.$bvModal.hide("deleteCodeQuestionModal");
			}
		},
		selecttestcase(index) {
			this.viewtestcase = index;
		},
		async viewQuestion(key) {
			const res = await getcodingquestion(key);
			this.question = res.data.data;
			this.viewtestcase = 0;
			this.$bvModal.show("viewQues");
		},
		goToEditQuestion(key) {
			let data = {
				name: "EditCodingTest",
				query: {
					testName: this.$route.params.testName,
					redirect: "QPBuilder",
					testID: this.$route.params.testID,
					topicName: this.$route.params.topicName,
					topicID: this.$route.params.topicID,
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					ttype: this.$route.query.ttype,
					tsort: this.$route.query.tsort,
					status: this.$route.query.status,
					sectionID: this.selectedSection.sectionID,
				},
			};
			if (typeof key !== "object") {
				data.query["questionKey"] = key;
			}
			this.$router.push(data);
		},
		async addCodeTestSection() {
			this.$v.$touch();

			if (!this.$v.section.name.$invalid) {
				this.section.topicID = this.selectedTopic.topicID;
				this.section.codingSection = true;
				const res = await postSection(this.section);
				if (res.status == 200) {
					this.sectionmodal = false;
					this.section["sectionID"] = res.data.data.sectionID;
					this.sectionDetails.push(this.section);
					this.selectSection(
						this.sectionDetails[this.sectionDetails.length - 1]
					);

					this.sectionsvalue.name = this.sectionDetails[
						this.sectionDetails.length - 1
					].name;
					this.sectionsvalue.codingSection = true;

					this.successToast("Coding section created successfully!");
					this.section = {
						testID: this.$route.params.testID,
						portion: "Section",
						name: "",
						topicID: "",
						numberOfQuestions: 0,
						questions: [],
						secMarks: 0,
						typeOfQuestions: [],
					};
					this.showcodetest = true;
					this.showadd = false;
					this.getSections();
					this.no_questions = true;
					this.$v.$reset();
					this.$bvModal.hide("addcodetest");
				} else if (res.status == 404) {
					this.errorToast(res.data.data.Data);
				} else {
					this.errorToast("Something went wrong!");
				}
			}
		},

		goToCreateQuestion() {
			let data = {
				name: "BuildingCodeTest",
				query: {
					testName: this.$route.params.testName,
					redirect: "QPBuilder",
					testID: this.$route.params.testID,
					topicName: this.$route.params.topicName,
					topicID: this.$route.params.topicID,
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					ttype: this.$route.query.ttype,
					tsort: this.$route.query.tsort,
					status: this.$route.query.status,
					sectionID: this.selectedSection.sectionID,
				},
			};
			this.$router.push(data);
		},

		clearData(type) {
			if (type == "MCQ") {
				this.resetMcqQuestion();
			} else if (type == "MTF") {
				this.resetMtfQuestion();
			} else if (type == "Descriptive") {
				this.resetDescriptiveQuestion();
			} else if (type == "COMU") {
				this.resetCommuQuestion();
			} else {
				this.resetMcqQuestion();
				this.resetMtfQuestion();
				this.resetDescriptiveQuestion();
				this.resetCommuQuestion();
			}
		},

		closecodetestmodal() {
			this.$bvModal.hide("addcodetest");
			this.section.name = "";
			this.$v.$reset();
		},
		naiveRound(num, decimalPlaces = 0) {
			let p = Math.pow(10, decimalPlaces);
			return Math.round(num * p) / p;
		},
		hideshowoptions() {
			this.showquesoptions = false;
		},
		hidesectionmodal() {
			this.sectionmodal = false;
		},

		goTobackpage() {
			this.$router.push({
				name: "Tests",
				params: {
					topicID: this.$route.params.topicID,
					topicName: this.$route.params.topicName,
				},
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					ttype: this.$route.query.ttype,
					tsort: this.$route.query.tsort,
				},
			});
		},
		// get all sections api
		getAllData() {
			console.log("emitted");
			this.getSections();
			this.getQuestions();
		},
		async getSections() {
			console.log("wen delete");

			try {
				const response = await getSection(this.$route.params.testID);
				if (response.status == 200) {
					const data = response.data.data;
					if (Object.keys(data).length > 0) {
						this.sectionDetails = data.sectionIDs;
					} else {
						this.sectionDetails = [];
					}

					if (this.sectionDetails.length === 0) {
						this.LoaderStatus = false;
					} else {
						this.handleGetSection();
					}
					// if (this.sectionDetails.some((s) => s.introQuestionAdded === true)) {
					// 	this.addIntroQues = true;
					// } else {
					// 	this.addIntroQues = false;
					// }
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		handleGetSection() {
			let selectedSectionIndex;

			if (Object.keys(this.selectedSection).length !== 0) {
				selectedSectionIndex = this.sectionDetails.findIndex(
					(i) => i.sectionID === this.selectedSection.sectionID
				);
			} else if (this.$route.query.sectionID) {
				for (const section of this.sectionDetails) {
					if (section.sectionID === this.$route.query.sectionID) {
						selectedSectionIndex = this.sectionDetails.indexOf(section);
						this.sectionsvalue.name = section.name;
						this.sectionsvalue.codingSection = true;
						this.sectionsvalue.communicationSection = true;
						this.checkEmptySection();
						break;
					}
				}
			}

			if (selectedSectionIndex !== undefined) {
				this.selectSection(this.sectionDetails[selectedSectionIndex]);
			} else {
				this.selectSection(this.sectionDetails[0]);
				this.sectionsvalue.name = this.sectionDetails[0].name;
			}

			this.checkEmptySection();
		},

		handleSectionResponse(response) {
			if (response.status === 200) {
				const data = response.data.data;
				if (Object.keys(data).length > 0) {
					this.sectionDetails = data.sectionIDs;
				} else {
					this.sectionDetails = [];
				}

				this.handleSectionDetails();
			}
		},

		handleSectionDetails() {
			if (this.sectionDetails.length === 0) {
				this.LoaderStatus = false;
			} else {
				this.handleSelectedSection();
			}
		},

		handleSelectedSection() {
			let selectedSectionIndex;

			if (Object.keys(this.selectedSection).length !== 0) {
				selectedSectionIndex = this.sectionDetails.findIndex(
					(i) => i.sectionID === this.selectedSection.sectionID
				);
			} else if (this.$route.query.sectionID) {
				selectedSectionIndex = this.findSectionIndexByQuery();
			}

			this.selectSectionAtIndex(selectedSectionIndex);
		},

		findSectionIndexByQuery() {
			for (const section of this.sectionDetails) {
				if (section.sectionID === this.$route.query.sectionID) {
					this.sectionsvalue.name = section.name;
					this.sectionsvalue.codingSection = true;
					this.sectionsvalue.communicationSection = true;
					this.checkEmptySection();
					return this.sectionDetails.indexOf(section);
				}
			}
		},

		selectSectionAtIndex(index) {
			if (index !== undefined) {
				this.selectSection(this.sectionDetails[index]);
			} else {
				this.selectDefaultSection();
			}
		},

		selectDefaultSection() {
			this.selectSection(this.sectionDetails[0]);
			this.sectionsvalue.name = this.sectionDetails[0].name;
			this.checkEmptySection();
		},

		resetFormValidations() {
			this.$nextTick(() => {
				if (this.addquestion === "MCQ" && this.$refs.mcqForm) {
					this.$refs.mcqForm.clearData();
				} else if (this.addquestion === "MTF" && this.$refs.mtfForm) {
					this.$refs.mtfForm.clearData();
				} else if (this.addquestion === "COMU" && this.$refs.commuForm) {
					this.$refs.commuForm.clearData();
				} else if (this.$refs.longForm) {
					this.$refs.longForm.clearData();
				}
			});
		},

		selectSection(i) {
			if (this.showadd || this.showComutest) {
				this.resetFormValidations();
			}

			const prevType = this.selectedSection
				? this.selectedSection.codingSection
					? "CODING"
					: this.selectedSection.communicationSection
					? "COMMUNICATION"
					: "STANDARD"
				: null;

			const newType = i.codingSection
				? "CODING"
				: i.communicationSection
				? "COMMUNICATION"
				: "STANDARD";

			if (prevType !== newType && this.$refs.databank) {
				this.$refs.databank.clearfilter?.();
				this.$refs.databank.selectedQuestions = [];
				this.$refs.databank.selectall = false;
			}

			this.LoaderStatus = true;
			this.selectedSection = i;

			this.sectionsvalue.name = i.name;
			this.sectionsvalue.codingSection = i.codingSection || false;
			this.sectionsvalue.communicationSection = i.communicationSection || false;

			if (i.communicationSection) {
				this.addIntroQues = !!i.introQuestionAdded;
				this.noOfQuestionsToAnswer =
					Object.prototype.hasOwnProperty.call(i, "noOfQuestionsToAnswer") &&
					i.noOfQuestionsToAnswer !== null
						? Number(i.noOfQuestionsToAnswer)
						: "";
			} else {
				this.addIntroQues = false;
				this.noOfQuestionsToAnswer = "";
			}

			if (i.codingSection) {
				this.showadd = false;
				this.showcodetest = true;
				this.showComutest = false;
			} else if (i.communicationSection) {
				this.showComutest = true;
				this.showadd = false;
				this.showcodetest = false;
			} else {
				this.showcodetest = false;
				this.showadd = true;
				this.showComutest = false;
			}

			this.sectionmodal = false;
			this.selectedSection.testID = this.$route.params.testID;

			this.$store.commit(
				"sectionVUEX/saveSelectedSection",
				this.selectedSection
			);

			this.getQuestions();
		},
		async getQuestions() {
			this.LoaderStatus = true;
			let payload = {
				testID: this.$route.params.testID,
				sectionID: this.selectedSection.sectionID,
			};
			const res = await getQuestions(payload);
			console.log("api called");

			if (res.status == 200) {
				this.questionData = res.data.data.questionsBody;
				this.$forceUpdate();
				this.LoaderStatus = false;
			} else {
				this.LoaderStatus = false;
			}
		},
		// add section
		async addSection() {
			this.$v.$touch();

			if (!this.$v.section.name.$invalid) {
				if (this.secOptionselected === "programng") {
					this.addCodeTestSection();
					this.$bvModal.hide("sectionNameModal");
					return;
				}
				this.section.topicID = this.selectedTopic.topicID;
				if (this.secOptionselected == "communication") {
					this.section.communicationSection = true;
				} else {
					this.section.communicationSection = false;
				}
				this.section.codingSection = false;

				const res = await postSection(this.section);
				if (res.status == 200) {
					this.sectionmodal = false;
					this.section["sectionID"] = res.data.data.sectionID;
					this.sectionDetails.push(this.section);
					this.selectSection(
						this.sectionDetails[this.sectionDetails.length - 1]
					);
					this.sectionsvalue.name = this.sectionDetails[
						this.sectionDetails.length - 1
					].name;
					this.sectionsvalue.codingSection = false;
					this.successToast("Section created successfully!");
					this.section = {
						testID: this.$route.params.testID,
						portion: "Section",
						name: "",
						topicID: "",
						numberOfQuestions: 0,
						questions: [],
						secMarks: 0,
						typeOfQuestions: [],
						codingSection: "",
					};
					this.showadd = true;
					this.getSections();
					this.no_questions = true;
					this.$v.$reset();
					this.$bvModal.hide("sectionNameModal");
				} else if (res.status == 404) {
					this.errorToast(res.data.data.Data);
				} else {
					this.errorToast("Something went wrong!");
				}
			}
		},
		//Delete Section Api
		async deleteSection() {
			let payload = {
				sectionID: this.selectedSection.sectionID,
				testID: this.$route.params.testID,
			};
			const res = await deleteSection(payload);
			if (res.status == 200) {
				this.successToast("Section deleted successfully!");
				this.sectionDetails = this.sectionDetails.filter(
					(data) => data.sectionID != payload.sectionID
				);
				if (this.sectionDetails.length > 0) {
					this.selectSection(
						this.sectionDetails[this.sectionDetails.length - 1]
					);
					this.sectionsvalue.name = this.sectionDetails[
						this.sectionDetails.length - 1
					].name;
					if (
						this.sectionDetails[this.sectionDetails.length - 1].codingSection
					) {
						this.sectionsvalue.codingSection = true;
					} else {
						this.sectionsvalue.codingSection = false;
					}
				} else {
					this.showadd = false;
				}
				this.checkEmptySection();
			} else {
				this.errorToast("Something went wrong!");
			}
			this.$bvModal.hide("delete-section-modal");
		},
		// Edit Section Api
		async editSection() {
			this.$v.$touch();
			if (!this.$v.copySection.name.$invalid) {
				this.selectedSection = this.copySection;
				this.selectedSection["portion"] = "Section";
				this.selectedSection["topicID"] = this.selectedTopic.topicID;
				this.selectedSection["testID"] = this.$route.params.testID;
				this.sectionsvalue.name = this.selectedSection.name;
				const res = await putSection(this.selectedSection);
				if (res.status == 200) {
					this.selectedSection.sectionID = res.data.data.sectionID;
					const index = this.sectionDetails.findIndex(
						(section) => section.sectionID == this.selectedSection.sectionID
					);
					if (index > -1) {
						this.sectionDetails[index].name = this.selectedSection.name;
					}
					this.successToast("Section updated successfully!");
				} else if (res.status == 409) {
					this.errorToast("Section name already exists");
				} else {
					this.errorToast("Something went wrong!");
				}

				this.$bvModal.hide("edit-section-modal");
			}
		},

		//  CHECK ALL SECTIONS HAS 0 QUESTIONS TO ENABLE OR DISABLE THE SHARE BUTTON
		checkEmptySection() {
			for (let i in this.sectionDetails) {
				if (this.sectionDetails[i].numberOfQuestions == 0) {
					this.no_questions = true;
					return;
				}
			}
			this.no_questions = false;
		},
		// select question type to add
		selectTypeQuestion(data) {
			this.addquestion = data; //to display the form components based on selection
			this.questionType = []; // letiable used to store the selected question type and to call databank api with selected filter
			if (data == "MCQ") {
				this.questionType.push("MCQU");
			} else if (data == "MTF") {
				this.questionType.push("MAFO");
			} else if (data == "Descriptive") {
				this.questionType.push("LONG");
			} else if (data == "COMU") {
				this.questionType.push("COMU");
			}
			this.showquesoptions = !this.showquesoptions;
			this.scrollToBottom();
		},
		// scroll to bottom of page when we click on add section button
		scrollToBottom() {
			const scrollContainer = document.getElementById("addcontainer");
			const bottomContainer = document.getElementById("add-question");
			scrollContainer.scrollTo({
				top: scrollContainer.scrollHeight - bottomContainer.offsetHeight - 20,
				left: 0,
				behavior: "smooth",
			});
		},
		// to check whether test has been shared to any group/individual
		async testShareCheck() {
			try {
				const res = await testSharedCheck(this.$route.params.testID);
				if (res.status == 200) {
					this.shareStatus = res.data.data.shareStatus;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		changeViewQuestionBank() {
			this.viewQuestionBank = !this.viewQuestionBank;
		},
		changeViewDataBank() {
			this.viewQuestionBank = false;
			if (this.showadd) setTimeout(() => this.scrollToBottom());
		},

		scroll(e) {
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				//this code will run when the user scrolls to the bottom of this div so
				//you could do an api call here to implement lazy loading
				if (this.nextPage != null) {
					this.currentPage++;
					let id = this.pageStart + "card";
					document.getElementById(id).scrollIntoView({
						behavior: `smooth`,
					});
				}
			}
		},
		searchnameupdate() {},
		goToGroupShare() {
			this.$store.commit(
				"testVUEX/saveSelectedTest",
				this.$route.params.testName
			);
			this.$router.push({
				path: `/share/sharewithpeople/${this.selectedTopic.topicID}/${this.$route.params.testID}`,
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					ttype: this.$route.query.ttype,
					tsort: this.$route.query.tsort,
					status: this.$route.query.status,
					testqp: "inside",
				},
			});
		},
		copySectionData() {
			this.copySection = { ...this.selectedSection };
		},
	},
};
</script>

<style>
.lock-test-noquestionsadd-text {
	font-family: "Poppins", sans-serif;
	font-size: 16px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0em;
	text-align: left;
	color: #72738e;
}
.width100 {
	width: 100% !important;
}
.codename-disable {
	color: #696969;
	opacity: 0.4;
	font-size: var(--size-14);
}
.bct-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}
.bct-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.bct-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}
.bct-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
}
.bct-many-testCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
}
.bct-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}
.qpc-modal-card-text {
	font-weight: 500;
	font-size: 13px;
	color: #333333;
}
.qpc-left-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 15px;
}
.qpc-full-ques {
	font-weight: 400;
	font-size: 14px;
	color: #585858;
}
.qpc-totalQuesnum {
	font-weight: 600;
	font-size: 14px;
	color: #333333;
}
.qpc-totalQuestext {
	font-weight: 500;
	font-size: 14px;
	color: #1d262d;
}
.qpc-tags-text {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.qpc-small-box {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	font-weight: 500;
	font-size: 11px;
	color: #3f698e;
	padding: 6px 17px;
	margin-right: 20px;
}
.qpc-modal-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 15px;
	min-height: auto;
	max-height: calc(100vh - 240px);
	overflow: auto;
}
.qpc-modal-head-text {
	font-weight: 500;
	font-size: 13px;
	color: #545454;
}
.codetest-colorbar {
	width: 4px;
	border-radius: 2px;
	margin: 3px;
	background: #7997bf;
}
.codetest-mark-tag {
	padding: 2px 25px;

	border-radius: 6px 0px 0px 0px;
	position: absolute;
	background: #7997bf;
	bottom: 0px;
	right: 0;
}
.qpb-typeradio:nth-child(odd) {
	background: #f4f4f4;
}

.qpb-typeradio:nth-child(even) {
	background: #fdfdfd;
}

.sec-selectdropdown .custom-select[multiple],
.custom-select[size]:not([size="1"]) {
	min-height: 0%;

	width: 100%;
}

.sort-radio-color .custom-control:nth-child(2n-1) {
	background: #fdfdfd;
	width: 100%;
}
.filter-count {
	width: 20px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding: 8px;
	/* padding-top: 2px; */
}
.sort-applied {
	width: 10px;
	border-radius: 10px;
	background: #ff7e47;
	height: 9px;
}
.db-ques-index {
	word-break: break-all;
}
.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
	border: 1px solid #72738e;

	padding: 5px 25px;
	border-radius: 3px;
}
.sel-ques-container {
	height: calc(100vh - 150px);
	position: relative;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}
.view-sel-ques-container {
	height: calc(100vh - 105px);
	position: relative;
	background: #ffffff;
	box-shadow: -5px 9px 25px rgb(0 0 0 / 15%);
	border-radius: 5px;
}
.search-top {
	box-sizing: border-box;

	width: 633px;
	height: 35px;
	left: 102px;
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
	border-radius: 3px;
}
.search-text {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 13px;
	color: #c4c4c4;
}
.sel-ques-sub-container {
	background: #e8f0fe;
	border: 1px solid #3379b3;
	box-shadow: 0px 0px 4px rgb(0 0 0 / 8%);
	border-radius: 10px;
}
.mcq-btn {
	width: 66px;

	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
}
.over-page {
	height: calc(100vh - 305px);
	overflow-y: auto;
	overflow-x: hidden;
}
.view-over-page {
	height: calc(100vh - 305px);
	overflow-y: auto;
	overflow-x: hidden;
}
.page-alignment {
	position: absolute;
	bottom: 0px;
	width: 100%;
	background: #f2f4fd;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
}
.sec-full-container {
	width: 100%;
}
.slide-enter-active {
	transition: 0.5s;
}

.slide-enter {
	transform: translate(100%, 0);
}

.x-markcancel-qpbuilder {
	border-radius: 50px;
	height: 20px;
	width: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--btn-border);
	cursor: pointer;
}
.view-sec-main-container {
	height: calc(100vh - 84px);
}
/* .sec-option-radios .custom-control-label::after {
	border: 2px solid white;
	border-radius: 50px;
} */
.sec-option-radios .custom-control-input {
	cursor: pointer;
}
.sec-option-radios .custom-control-label {
	cursor: pointer;
}
</style>
